import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, FormControl, Input, InputAdornment, InputLabel, makeStyles, Table, TableBody, TableCell, TableFooter, TableHead, TableRow } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import {getFormData} from '../store/slices/formDataSlice';
import {styled} from '@material-ui/core';
import { BlackCell, BlackCellBorderWhite, BlueCell, BrightYellowCell, BrightYellowCellBorder, DarkBlueCell, DarkBlueCellBorder, DarkGreyCell, DarkGreyCellBorder, GreenCell, InstyleTable, LightBlueCellBorder, LightGreyCell, LightYellowCell, LightYellowCellBorder, StyledTableRow, TableInput, TableSelect } from '../components/Page/TableStyles';
// import YourSystemTable from '../components/SavingsEstimate/YourSystemTable';
import {SpacedDiv} from '../components/Page/FormStyles'
import InputTable from '../components/SavingsEstimate/InputTable';
import { calculateDailyExport, calculateDailyProduction, calculateDailyUsage, calculateQuarterly, calculateYearly, formatMoneyCents, sunHours } from '../helpers';
import YourSystemTable from '../components/SavingsEstimate/YourSystemTable';
import MaximumSavingsTable from '../components/SavingsEstimate/MaximumSavingsTable';
import MinimumSavingsTable from '../components/SavingsEstimate/MinimumSavingsTable';
import { MinMaxTable } from '../components/SavingsEstimate/MinMaxTable';
import BreakdownTable from '../components/SavingsEstimate/BreakdownTable';
import FutureBreakdownTable from '../components/SavingsEstimate/FutureBreakdownTable';

export const SavingEstimatePath = "/savings-estimate";

//step 1 electricity costs page
export function SavingEstimate(props) {

    const formData = useSelector(getFormData);

    const dailyProduction = Math.round(calculateDailyProduction() * 100) / 100;
    const estimatedDailyUsage = Math.floor(calculateDailyUsage() * 100) / 100;
    const estimatedDailyExport = Math.floor(calculateDailyExport() * 100) / 100;

    var selectedBattery = formData.batteryOffered && formData.allProducts && formData.allProducts.loaded && formData.allProducts.data.Batteries ?
        formData.allProducts.data.Batteries.find(b => {
            return b.SKU === formData.selectedBattery;
        }) : null;
    var estimatedStorage = 0.0;
    if (selectedBattery && selectedBattery?.Size) {
        estimatedStorage = estimatedDailyExport < parseFloat(selectedBattery.Size) ? estimatedDailyExport : parseFloat(selectedBattery.Size);
    }
    const estimatedDailyExportAfterStorage = estimatedDailyExport - estimatedStorage;

    const increasedDailyCharge = formData.powerPrice * (formData.twelveMonthIncrease / 100 + 1);
    const increasedDailyFIT = formData.feedInTariff * (formData.twelveMonthIncrease / 100 + 1);

    return (
        <div style={{position: 'relative'}}>
            <div style={{padding: '10px 30px', width: '100%', height: '100%'}}>
                <div style={{width: '100%', display: 'grid', gridTemplateColumns: '1fr 1fr'}}>
                    <InputTable sunHours={sunHours} />
                </div>
                <hr></hr>
                {/* end of top forms */}
                <SpacedDiv>
                    <YourSystemTable formData={formData} dailyProduction={dailyProduction} sunHours={sunHours} />
                </SpacedDiv>
                {/* end of your system table */}
                <SpacedDiv>
                    <MaximumSavingsTable formData={formData} dailyProduction={dailyProduction} />
                </SpacedDiv>
                {/* end maximum savings breakdown */}
                <SpacedDiv>
                    <MinimumSavingsTable formData={formData} dailyProduction={dailyProduction} />
                </SpacedDiv>
                {/* end of minimum sales table */}
                <SpacedDiv>
                    <MinMaxTable formData={formData} dailyProduction={dailyProduction} />
                </SpacedDiv>
                {/* end of min/max table compare */}
                <SpacedDiv>
                    <BreakdownTable
                        formData={formData}
                        estimatedDailyUsage={estimatedDailyUsage}
                        estimatedStorage={estimatedStorage}
                        estimatedDailyExportAfterStorage={estimatedDailyExportAfterStorage}
                    />
                </SpacedDiv>
                <SpacedDiv>&nbsp;</SpacedDiv>
                <SpacedDiv>
                    <FutureBreakdownTable
                        formData={formData}
                        estimatedDailyUsage={estimatedDailyUsage}
                        increasedDailyCharge={increasedDailyCharge}
                        increasedDailyFIT={increasedDailyFIT}
                        estimatedStorage={estimatedStorage}
                        estimatedDailyExportAfterStorage={estimatedDailyExportAfterStorage}
                    />
                </SpacedDiv>
            </div>
        </div>

    )
}

export default SavingEstimate;